"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_1 = require("react");
const hui_1 = require("@mit/hui");
const UserController_1 = __importDefault(require("../../api/UserController"));
const PersonProfilePicture = ({ id, highResolution, type, person }) => {
    const [profilePicture, setProfilePicture] = (0, react_1.useState)("");
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setProfilePicture(null);
        if (id) {
            setLoading(true);
            UserController_1.default.fetchPicture(id, highResolution).then((response) => {
                if (response.value) {
                    setProfilePicture(response.value);
                    setLoading(false);
                }
            });
        }
    }, [id, highResolution]);
    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [type === "rounded" && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "profile-pic" }, { children: profilePicture ? (0, jsx_runtime_1.jsx)("img", { src: profilePicture, alt: "profile" }) : (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "user" }) })), type === "round-large" && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "profile-pic-large" }, { children: profilePicture ? (0, jsx_runtime_1.jsx)("img", { src: profilePicture, alt: "profile" }) : (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "user" }) })), type === "large" && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "main-profile-header m-4" }, { children: (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "user-image" }, { children: [isLoading && (0, jsx_runtime_1.jsx)(hui_1.SkeletonLoader, { type: `large-image` }), !isLoading && profilePicture && (0, jsx_runtime_1.jsx)("img", { src: profilePicture, alt: `${person || ''} Profile Picture`, className: "img-object-large-fit" })] })) })))] }));
};
exports.default = PersonProfilePicture;
PersonProfilePicture.defaultProps = {
    type: "rounded",
};
